import { apiGet } from '@/store/api';
import { useHelperStore } from '@/store/helperStore';

export async function getTeams() {
  const data = await apiGet('helper/teams');
  useHelperStore().setTeams(data);
}
